import { render, staticRenderFns } from "./CommunicationsServiceProviderName.vue?vue&type=template&id=19c37c20&"
import script from "./CommunicationsServiceProviderName.vue?vue&type=script&lang=js&"
export * from "./CommunicationsServiceProviderName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19c37c20')) {
      api.createRecord('19c37c20', component.options)
    } else {
      api.reload('19c37c20', component.options)
    }
    module.hot.accept("./CommunicationsServiceProviderName.vue?vue&type=template&id=19c37c20&", function () {
      api.rerender('19c37c20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/outputs/CommunicationsServiceProviderName.vue"
export default component.exports